import { render, staticRenderFns } from "./DbMapping.vue?vue&type=template&id=0a231144"
import script from "./DbMapping.vue?vue&type=script&lang=js"
export * from "./DbMapping.vue?vue&type=script&lang=js"
import style0 from "./DbMapping.vue?vue&type=style&index=0&id=0a231144&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports